import { Route, Routes } from "react-router-dom";
import TeamManagement from "./TeamManagement";

export default function TeamManagementRouter() {
  return (
    <Routes>
      <Route path="/" element={<TeamManagement />} />
    </Routes>
  );
}
